import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FeatureFlagContainer, SetGlobalStyle } from '@vezeeta/web-components';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import EnterpriseLayout from '@vezeeta/enterprise-layout';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MixpanelConsumer } from 'react-mixpanel';
import '@vezeeta/enterprise-modals/lib/Modal.css';
import { toggleTutorialModal } from '@vezeeta/enterprise-store/lib/actions/bid';
import { language } from '@vezeeta/enterprise-store/lib/types/language';
import { BidsDashBoard, PaymentDetails } from 'app/Routes';
import { withTranslation } from 'app/withTranslation/withTranslation';
import '@vezeeta/web-components/lib/shared/Utils.css';
import RoleBasedRoute from 'app/RoleBasedAccess/RoleBasedRoute';
import { extendContentContainer } from './App.style';
import { isSupportSingleLanguage, getFeatureFlags, getbreadCrumbSteps } from './App.helper';

const App = ({ ...props }) => {
  useEffect(() => {
    SetGlobalStyle();
  }, []);

  const { user, isUserLoaded, clinics, localization } = props;
  const supportSingleLanguage = isSupportSingleLanguage(user, isUserLoaded);

  return (
    <FeatureFlagContainer.Provider value={getFeatureFlags()}>
      <Router>
        <EnterpriseLayout
          supportSingleLanguage={supportSingleLanguage}
          breadcrumbProps={getbreadCrumbSteps(localization, language, props.toggleTutorialModal)}
          activeTab="Sponsered"
          extendContentContainer={extendContentContainer}
        >
          <React.Fragment>
            <MixpanelConsumer>
              {mixpanel => (
                <Switch>
                  <RoleBasedRoute
                    path="/"
                    exact
                    isUserLoaded={isUserLoaded}
                    localization={localization}
                    render={routeProps => (
                      <BidsDashBoard
                        {...routeProps}
                        {...props}
                        mixpanel={mixpanel}
                        supportSingleLanguage={supportSingleLanguage}
                        clinics={clinics}
                        localization={localization}
                        language={language}
                      />
                    )}
                  />
                  <RoleBasedRoute
                    path="/paymentdetails"
                    exact
                    isUserLoaded={isUserLoaded}
                    localization={localization}
                    render={routeProps => (
                      <PaymentDetails
                        {...routeProps}
                        {...props}
                        mixpanel={mixpanel}
                        supportSingleLanguage={supportSingleLanguage}
                        clinics={clinics}
                        localization={localization}
                        language={language}
                      />
                    )}
                  />
                </Switch>
              )}
            </MixpanelConsumer>
          </React.Fragment>
        </EnterpriseLayout>
      </Router>
    </FeatureFlagContainer.Provider>
  );
};

const mapStateToProps = state => ({
  isUserLoaded: state.user.loaded,
  user: state.user.user,
  clinics: state.clinics.Clinics,
  snackBar: state.bids.snackBar,
});

App.propTypes = {
  isUserLoaded: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  clinics: PropTypes.object.isRequired,
  localization: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleTutorialModal,
    },
    dispatch,
  );

export default withTranslation(connect(mapStateToProps, mapDispatchToProps)(App));
